import React, { Component } from 'react';
import { HashRouter, Switch, Route } from 'react-router-dom'
import './App.css';
import Main from './Components/Main'
import Room from './Components/Room';

class App extends Component {

  render() {
    return (
      <HashRouter>
        <div className="App bg-light">
        <Switch>
          <Route path='/' exact component={Main} />
          <Route path='/room/:roomId' component={Room}/>
        </Switch>
        </div>
      </HashRouter>

    );
  }
}

export default App;
